import { useState, useEffect } from 'react';
import { getAuth, signInWithPopup, OAuthProvider } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../services/firebase';
import { googleAuthService } from '../services/googleAuth';
import token from '../assets/dollar.png';  // Добавьте импорт иконки токена
import  appstore from '../assets/appstore.png'
export const useAppleAuth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);
  const [showAuthForm, setShowAuthForm] = useState(false);
  
  const auth = getAuth();

  // Загружаем Apple JS SDK
  useEffect(() => {
    if (!document.getElementById('apple-signin-sdk')) {
      const script = document.createElement('script');
      script.id = 'apple-signin-sdk';
      script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }, []);

  const login = async () => {
    console.log('🔄 Начало процесса входа через Apple');
    setLoading(true);
    setError(null);

    try {
      // Создаем модальное окно с официальной кнопкой Apple
      const modal = document.createElement('div');
      modal.style.position = 'fixed';
      modal.style.top = '0';
      modal.style.left = '0';
      modal.style.width = '100%';
      modal.style.height = '100%';
      modal.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
      modal.style.zIndex = '9999';
      modal.style.display = 'flex';
      modal.style.justifyContent = 'center';
      modal.style.alignItems = 'center';
      
      const modalContent = document.createElement('div');
      modalContent.style.backgroundColor = 'white';
      modalContent.style.borderRadius = '10px';
      modalContent.style.padding = '30px';
      modalContent.style.maxWidth = '400px';
      modalContent.style.width = '90%';
      modalContent.style.boxShadow = '0 5px 15px rgba(0,0,0,0.3)';
      
      const modalTitle = document.createElement('h3');
      modalTitle.textContent = 'Choose login method';
      modalTitle.style.marginBottom = '20px';
      modalTitle.style.color = 'purple';
      modalTitle.style.textAlign = 'center';
      modalTitle.style.fontSize = '20px';
      modalTitle.style.fontWeight = 'bold';
      modalTitle.style.textTransform = 'uppercase';
      modalTitle.style.fontFamily = '-apple-system, Black han sans';
      
      // Функция для закрытия модального окна
      const closeModal = () => {
        console.log('🔄 Закрытие модального окна');
        if (document.body.contains(modal)) {
          document.body.removeChild(modal);
          setLoading(false);
        }
      };

      // Добавляем обработчик клика вне модального содержимого для закрытия
      modal.onclick = (event) => {
        if (event.target === modal) {
          closeModal();
        }
      };

      // Добавляем обработчик клавиши Escape для закрытия
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && document.body.contains(modal)) {
          closeModal();
        }
      });

      // Настраиваем крестик закрытия
      const closeButton = document.createElement('button');
      closeButton.textContent = '✕';
      closeButton.style.position = 'absolute';
      closeButton.style.top = '10px';
      closeButton.style.right = '10px';
      closeButton.style.background = 'none';
      closeButton.style.border = 'none';
      closeButton.style.fontSize = '20px';
      closeButton.style.cursor = 'pointer';
      closeButton.onclick = closeModal;
      
      // Настраиваем провайдера Apple с самыми базовыми параметрами
      console.log('📝 Настройка Apple провайдера');
      const provider = new OAuthProvider('apple.com');
      
      // Только необходимые области
      provider.addScope('email');
      provider.addScope('name');
      
      // Создаем кнопку для входа через Google (теперь первая)
      const googleSignInButton = document.createElement('button');
      googleSignInButton.innerHTML = '<img src="https://developers.google.com/identity/images/g-logo.png" style="height: 20px; margin-right: 10px;"> Sign in with Google';
      googleSignInButton.style.backgroundColor = 'white';
      googleSignInButton.style.color = '#757575';
      googleSignInButton.style.padding = '10px 20px';
      googleSignInButton.style.border = '1px solid #ddd';
      googleSignInButton.style.borderRadius = '5px';
      googleSignInButton.style.cursor = 'pointer';
      googleSignInButton.style.display = 'flex';
      googleSignInButton.style.alignItems = 'center';
      googleSignInButton.style.justifyContent = 'center';
      googleSignInButton.style.width = '100%';
      googleSignInButton.style.fontSize = '16px';
      googleSignInButton.style.boxShadow = '0 1px 3px rgba(0,0,0,0.2)';
      googleSignInButton.style.marginBottom = '15px';
      googleSignInButton.onclick = () => {
        // Удаляем текущее модальное окно
        closeModal();
        
        // Используем сервис аутентификации Google напрямую, без хуков
        googleAuthService.login()
          .then(result => {
            if (result && result.user) {
              setUser(result.user);
            }
          })
          .catch(err => {
            console.error('Ошибка при входе через Google:', err);
            setError('Ошибка при входе через Google');
          });
      };
      
      // Добавляем разделитель
      const divider = document.createElement('div');
      divider.style.display = 'flex';
      divider.style.alignItems = 'center';
      divider.style.margin = '15px 0';
      
      const line1 = document.createElement('div');
      line1.style.flex = '1';
      line1.style.height = '1px';
      line1.style.backgroundColor = '#ddd';
      
      const orText = document.createElement('span');
      orText.textContent = ' or ';
      orText.style.padding = '0 10px';
      orText.style.color = '#777';
      
      const line2 = document.createElement('div');
      line2.style.flex = '1';
      line2.style.height = '1px';
      line2.style.backgroundColor = '#ddd';
      
      divider.appendChild(line1);
      divider.appendChild(orText);
      divider.appendChild(line2);
      
      // Создаем кнопку входа через Apple (теперь вторая и в стиле Google)
      const signInButton = document.createElement('button');
      signInButton.innerHTML = `<img src=${appstore} style="height: 20px; margin-right: 10px;"> Sign in with Apple`;
      signInButton.style.backgroundColor = 'white';
      signInButton.style.color = '#757575';
      signInButton.style.padding = '10px 20px';
      signInButton.style.border = '1px solid #ddd';
      signInButton.style.borderRadius = '5px';
      signInButton.style.cursor = 'pointer';
      signInButton.style.display = 'flex';
      signInButton.style.alignItems = 'center';
      signInButton.style.justifyContent = 'center';
      signInButton.style.width = '100%';
      signInButton.style.fontSize = '16px';
      signInButton.style.boxShadow = '0 1px 3px rgba(0,0,0,0.2)';
      signInButton.style.marginBottom = '15px';
      signInButton.onclick = async () => {
        console.log('🔄 Нажатие на кнопку входа через Apple');
        try {
          // Устанавливаем настройки для обхода проблем с COOP
          auth.settings.appVerificationDisabledForTesting = true;
          
          // При клике выполняем аутентификацию
          console.log('🔑 Вызов signInWithPopup для Apple аутентификации');
          const result = await signInWithPopup(auth, provider);
          console.log('🔍 Результат входа:', result);
          
          if (result && result.user) {
            console.log('👤 Пользователь авторизован:', result.user.uid);
            try {
              // Если успешно, закрываем модальное окно
              closeModal();
            } catch (removeError) {
              console.error('❌ Ошибка при закрытии модального окна:', removeError);
            }
            
            // Обрабатываем пользователя
            console.log('🔄 Обработка данных пользователя');
            const userData = await processUserData(result.user);
            console.log('✅ Данные пользователя обработаны:', userData);
            setUser(userData);
            
            // Создаем модальное окно успешного входа
            console.log('🎉 Создание модального окна специального предложения');
            createSuccessModal(userData);
            
            // Уведомляем об успешной аутентификации
            console.log('📢 Отправка события успешной аутентификации');
            window.dispatchEvent(new CustomEvent('appleAuthComplete', {
              detail: { success: true, user: userData }
            }));
          }
        } catch (err) {
          console.error('❌ Ошибка при входе через Apple:', err);
          
          // Показываем ошибку в модальном окне
          const errorElement = document.createElement('p');
          errorElement.textContent = 'Произошла ошибка при входе через Apple. Пожалуйста, попробуйте позже.';
          errorElement.style.color = 'red';
          errorElement.style.marginTop = '10px';
          errorElement.style.textAlign = 'center';
          
          modalContent.appendChild(errorElement);
          
          setError('Ошибка аутентификации с Apple');
        }
      };
      
      modalContent.appendChild(closeButton);
      modalContent.appendChild(modalTitle);
      modalContent.appendChild(googleSignInButton);
      modalContent.appendChild(divider);
      modalContent.appendChild(signInButton);
      modal.appendChild(modalContent);
      document.body.appendChild(modal);
      
      // Добавляем функцию для модального окна успешного входа
      const createSuccessModal = (userData) => {
        console.log('🎨 Создание модального окна успешного входа по дизайну скриншота');
        
        // Определяем, новый ли пользователь
        const isNewUser = userData.isNewUser;
        
        // Создаем контейнер модального окна
        const modal = document.createElement('div');
        modal.style.position = 'fixed';
        modal.style.top = '0';
        modal.style.left = '0';
        modal.style.width = '100%';
        modal.style.height = '100%';
        modal.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        modal.style.zIndex = '9999';
        modal.style.display = 'flex';
        modal.style.justifyContent = 'center';
        modal.style.alignItems = 'center';
        
        // Функция закрытия модального окна в createSuccessModal
        const closeSuccessModal = () => {
          console.log('🔄 Закрытие модального окна успешного входа');
          if (document.body.contains(modal)) {
            document.body.removeChild(modal);
          }
        };

        // Закрытие по клику вне окна
        modal.onclick = (event) => {
          if (event.target === modal) {
            closeSuccessModal();
          }
        };

        // Закрытие по нажатию Escape
        const handleKeyDown = (event) => {
          if (event.key === 'Escape') {
            closeSuccessModal();
            // Удаляем обработчик после закрытия
            document.removeEventListener('keydown', handleKeyDown);
          }
        };
        document.addEventListener('keydown', handleKeyDown);
        
        // Создаем содержимое модального окна
        const modalContent = document.createElement('div');
        modalContent.style.backgroundColor = 'white';
        modalContent.style.borderRadius = '20px';
        modalContent.style.padding = '30px';
        modalContent.style.maxWidth = '400px';
        modalContent.style.width = '90%';
        modalContent.style.boxShadow = '0 5px 15px rgba(0,0,0,0.3)';
        modalContent.style.textAlign = 'center';
        modalContent.style.position = 'relative';
        
        // Добавляем кнопку закрытия
        const closeButton = document.createElement('button');
        closeButton.innerHTML = '&times;';
        closeButton.style.position = 'absolute';
        closeButton.style.top = '15px';
        closeButton.style.right = '15px';
        closeButton.style.backgroundColor = 'transparent';
        closeButton.style.border = 'none';
        closeButton.style.fontSize = '30px';
        closeButton.style.lineHeight = '1';
        closeButton.style.color = '#aaa';
        closeButton.style.cursor = 'pointer';
        closeButton.style.padding = '0';
        closeButton.style.width = '30px';
        closeButton.style.height = '30px';
        closeButton.style.display = 'flex';
        closeButton.style.alignItems = 'center';
        closeButton.style.justifyContent = 'center';
        closeButton.onclick = closeSuccessModal;
        
        // Добавляем заголовок
        const modalTitle = document.createElement('h2');
        modalTitle.textContent = isNewUser ? 'Exclusive Offer' : 'Special Offer';
        modalTitle.style.color = '#f9c846'; // Желтый цвет как в googleAuth
        modalTitle.style.fontSize = '32px';
        modalTitle.style.fontWeight = 'bold';
        modalTitle.style.marginBottom = '25px';
        modalTitle.style.marginTop = '0px';
        modalTitle.style.fontFamily = '-apple-system, Black han sans';
        
        // Создаем список преимуществ
        const benefitsList = document.createElement('div');
        benefitsList.style.marginBottom = '30px';
        benefitsList.style.textAlign = 'left';
        
        // Функция для создания элемента преимущества
        const createBenefitItem = (icon, title, description, highlight = null) => {
          const benefitItem = document.createElement('div');
          benefitItem.style.display = 'flex';
          benefitItem.style.alignItems = 'flex-start';
          benefitItem.style.marginBottom = '20px';
          
          // Иконка преимущества
          const benefitIcon = document.createElement('div');
          benefitIcon.style.width = '40px';
          benefitIcon.style.height = '40px';
          benefitIcon.style.borderRadius = '10px';
          benefitIcon.style.display = 'flex';
          benefitIcon.style.alignItems = 'center';
          benefitIcon.style.justifyContent = 'center';
          benefitIcon.style.marginRight = '15px';
          benefitIcon.style.flexShrink = '0';
          
          // Если иконка - изображение
          if (typeof icon === 'string' && icon.includes('/')) {
            const iconImg = document.createElement('img');
            iconImg.src = icon;
            iconImg.style.width = '24px';
            iconImg.style.height = '24px';
            benefitIcon.appendChild(iconImg);
          } else {
            // Если иконка - эмоджи или текст
            benefitIcon.innerHTML = `<span style="font-size: 24px;">${icon}</span>`;
          }
          
          // Текстовый блок преимущества
          const benefitText = document.createElement('div');
          benefitText.style.flex = '1';
          
          // Заголовок преимущества
          const benefitTitle = document.createElement('div');
          benefitTitle.style.fontWeight = '600';
          benefitTitle.style.fontSize = '17px';
          benefitTitle.style.color = '#333';
          benefitTitle.style.marginBottom = '4px';
          
          // Если есть выделенный текст, форматируем заголовок с выделением
          if (highlight) {
            const titleParts = title.split(highlight);
            benefitTitle.innerHTML = titleParts[0];
            
            const highlightSpan = document.createElement('span');
            highlightSpan.textContent = highlight;
            highlightSpan.style.color = '#f9c846';
            highlightSpan.style.fontWeight = '700';
            highlightSpan.style.fontSize = '20px';
            
            benefitTitle.appendChild(highlightSpan);
            
            if (titleParts[1]) {
              benefitTitle.innerHTML += titleParts[1];
            }
          } else {
            benefitTitle.textContent = title;
          }
          
          // Описание преимущества
          const benefitDescription = document.createElement('div');
          benefitDescription.textContent = description;
          benefitDescription.style.fontSize = '14px';
          benefitDescription.style.color = '#666';
          benefitDescription.style.lineHeight = '1.4';
          
          benefitText.appendChild(benefitTitle);
          benefitText.appendChild(benefitDescription);
          
          benefitItem.appendChild(benefitIcon);
          benefitItem.appendChild(benefitText);
          
          return benefitItem;
        };
        
        // Добавляем элементы преимуществ (аналогично DownloadPrompt)
        const tokenCount = isNewUser ? '126' : '96';
        benefitsList.appendChild(createBenefitItem(
          token, 
          `Get ${tokenCount} tokens`, 
          'to create amazing recipes from your leftovers',
          tokenCount
        ));
        
        benefitsList.appendChild(createBenefitItem(
          '🍽️', 
          'Make 3 meals at once', 
          'instead of just one recipe idea',
          '3'
        ));
        
        benefitsList.appendChild(createBenefitItem(
          '✨', 
          'Personalized cooking', 
          'tailored to your preferences and dietary needs'
        ));
        
        // Создаем кнопку App Store
        const appStoreButtonContainer = document.createElement('div');
        appStoreButtonContainer.style.borderRadius = '10px';
        appStoreButtonContainer.style.padding = '10px 0';
        appStoreButtonContainer.style.margin = '0 auto 25px';
        appStoreButtonContainer.style.width = '100%';
        appStoreButtonContainer.style.maxWidth = '350px';
        appStoreButtonContainer.style.cursor = 'pointer';
        
        const appStoreLink = document.createElement('a');
        appStoreLink.href = 'https://apps.apple.com/us/app/chefkats-ai-snap-cook/id6739225693';
        appStoreLink.target = '_blank';
        appStoreLink.style.textDecoration = 'none';
        appStoreLink.style.display = 'block';
        
        // Используем изображение кнопки App Store
        const appStoreImg = document.createElement('img');
        appStoreImg.src = 'https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg';
        appStoreImg.alt = 'Download on the App Store';
        appStoreImg.style.height = '56px';
        appStoreImg.style.margin = '0 auto';
        appStoreImg.style.display = 'block';
        
        appStoreLink.appendChild(appStoreImg);
        appStoreButtonContainer.appendChild(appStoreLink);
        
        appStoreButtonContainer.onclick = () => {
          console.log('🔄 Переход в App Store');
          window.open('https://apps.apple.com/us/app/chefkats-ai-snap-cook/id6739225693', '_blank');
          
          // Закрываем модальное окно
          setTimeout(() => {
            if (document.body.contains(modal)) {
              document.body.removeChild(modal);
            }
          }, 300);
        };
        
        // Создаем кнопку "Maybe later"
        const laterButton = document.createElement('button');
        laterButton.textContent = 'Maybe later';
        laterButton.style.backgroundColor = '#fff';
        laterButton.style.color = '#666';
        laterButton.style.border = 'none';
        laterButton.style.padding = '12px 30px';
        laterButton.style.borderRadius = '50px'; // Скругленная кнопка
        laterButton.style.fontSize = '14px';
        laterButton.style.cursor = 'pointer';
        laterButton.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)'; // Легкая тень
        laterButton.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
        laterButton.onclick = closeSuccessModal;
        
        // Собираем модальное окно
        modalContent.appendChild(closeButton);
        modalContent.appendChild(modalTitle);
        modalContent.appendChild(benefitsList); // Добавляем список преимуществ
        modalContent.appendChild(appStoreButtonContainer);
        modalContent.appendChild(laterButton);
        modal.appendChild(modalContent);
        
        // Добавляем на страницу
        document.body.appendChild(modal);
        
        console.log('✅ Модальное окно специального предложения создано в стиле DownloadPrompt');
      };
      
      return { success: true }; // Возвращаем результат, даже если пользователь просто закроет модальное окно
      
    } catch (error) {
      console.error('❌ Ошибка аутентификации с Apple:', error);
      
      let errorMessage = 'Произошла ошибка при входе через Apple';
      setError(errorMessage);
      
      // Отправляем событие об ошибке аутентификации
      console.log('📢 Отправка события об ошибке аутентификации');
      window.dispatchEvent(new CustomEvent('appleAuthComplete', { 
        detail: { success: false, error: errorMessage } 
      }));
      
      return { error: errorMessage, success: false };
    } finally {
      setLoading(false);
    }
  };

  // Обработка данных пользователя в Firestore с добавленным логированием
  const processUserData = async (firebaseUser) => {
    console.log('🔄 Обработка данных пользователя в Firestore:', firebaseUser.uid);
    
    try {
      // Проверяем существует ли пользователь в Firestore
      const userDocRef = doc(db, 'users', firebaseUser.uid);
      const userSnapshot = await getDoc(userDocRef);

      console.log('🔍 Проверка существования пользователя в БД:', userSnapshot.exists());

      if (!userSnapshot.exists()) {
        console.log('🆕 Создание нового пользователя');
        // Создаем нового пользователя
        const userData = {
          uid: firebaseUser.uid,
          email: firebaseUser.email || '',
          displayName: firebaseUser.displayName || '',
          favoritesFood: [],
          preferences: [],
          tools: [],
          catType: 'gray',
          userAnalytics: {
            showTutorial: true,
            showClaim: true,
          },
          isPro: false,
          promoGenerations: 0,
          tokens: 126, // Для новых пользователей 126 токенов
          authProvider: 'apple',
          registrationDate: new Date().toISOString(),
          lastLoginDate: new Date().toISOString(),
        };

        console.log('📝 Сохранение данных нового пользователя:', userData);
        await setDoc(userDocRef, userData);
        console.log('✅ Новый пользователь сохранен в Firestore');
        
        return {...userData, isNewUser: true};
      } else {
        console.log('👤 Обновление данных существующего пользователя');
        // Обновляем дату последнего входа
        const existingData = userSnapshot.data();
        console.log('📝 Текущие данные пользователя:', existingData);
        
        await setDoc(userDocRef, {
          ...existingData,
          lastLoginDate: new Date().toISOString()
        }, { merge: true });
        
        console.log('✅ Данные пользователя обновлены в Firestore');
        return {...existingData, isNewUser: false};
      }
    } catch (error) {
      console.error('❌ Ошибка при обработке данных пользователя:', error);
      throw error;
    }
  };

  return { login, loading, error, user };
}; 